module.exports = __webpack_public_path__ + "img/cabinet_Maple.134ee3d6.png";